import { Component, EventEmitter, Input, Output } from '@angular/core';


export enum KeyResultItemStatus {
  COMPLETED = "COMPLETED",
  INPROGRESS = "INPROGRESS",
  NOTAVAILABLE = "NOTAVAILABLE",
  COMINGSOON = "COMINGSOON"
}

@Component({
  selector: 'app-key-result-item',
  standalone: false,
  templateUrl: './key-result-item.component.html',
  styleUrl: './key-result-item.component.scss'
})
export class KeyResultItemComponent {

  // Inputs
  @Input() label: string = "";
  @Input() status: KeyResultItemStatus = KeyResultItemStatus.COMPLETED;
  @Input() value: boolean | undefined = undefined;

  // Outputs
  @Output() createClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() showClicked: EventEmitter<void> = new EventEmitter<void>();

  // Objects
  KeyResultItemStatus = KeyResultItemStatus;

}
